import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaArrowUp, FaArrowDown } from "react-icons/fa"; // Import icons

const ScrollButtonsContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;

  @media (max-width: 768px) {
    display: none; // Hide on mobile screens
  }
`;

const ScrollButton = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
  }
`;

const ScrollButtons: React.FC = () => {
  const [showScrollUp, setShowScrollUp] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(true);

  useEffect(() => {
    const checkScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      setShowScrollUp(scrollPosition > 300); // Show Up Arrow after scrolling 300px
      setShowScrollDown(scrollPosition + windowHeight < documentHeight - 100); // Hide Down Arrow near bottom
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
  };

  return (
    <ScrollButtonsContainer>
      {showScrollUp && (
        <ScrollButton onClick={scrollToTop}>
          <FaArrowUp size={24} />
        </ScrollButton>
      )}
      {showScrollDown && (
        <ScrollButton onClick={scrollToBottom}>
          <FaArrowDown size={24} />
        </ScrollButton>
      )}
    </ScrollButtonsContainer>
  );
};

export default ScrollButtons;
